export default __webpack_public_path__ + "static/media/SilkScreenPrintingImg.655bd79e.jpg";